import { getUserStore } from '../store/store';
import { mutatorAction } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';
import type { PrioritizeViewOpenedContext } from '../store/schema/PriorityInboxStore';

export const setViewOpenedContextMutator: (
    mailboxInfo: MailboxInfo,
    context: PrioritizeViewOpenedContext | undefined
) => void = mutatorAction(
    'setViewOpenedContextMutator',
    (mailboxInfo: MailboxInfo, context: PrioritizeViewOpenedContext | undefined): void => {
        const store = getUserStore(mailboxInfo);
        store.viewOpenedContext = context;
    }
);
